import { useCallback } from "react";
import { Form } from "react-bootstrap";

const InputDate = (props) => {
  const { className, name, value, checked, onBlur, onChange, onFocus, meta, field, ...attributes } = props || {};
  const { label, ariaLabel } = field || {};

  const noEffekt = (e) => {
    if (e) e.preventDefault();
  };

  const changeDate = useCallback((e) => {
    if (typeof onChange === "function") {
      onChange(e);
    }
  }, [onChange]);

  const today = new Date();
  const min = (today.getFullYear() - 4) + "-01-01";

  return <div className={"row " + className}>
    <Form.Label htmlFor={name} className="col-6 col-form-label col-form-label-sm" >{label}</Form.Label>
    <div className="col-6">
      <Form.Control
        type="date"
        id={name}
        name={name}
        value={value}
        onChange={changeDate}
        onFocus={noEffekt}
        onBlur={noEffekt}
        aria-label={ariaLabel}
        {...attributes}
        size="sm"
        min={min}
        max={today.toISOString().substring(0, 10)}
      />
    </div>
  </div>;
};
export default InputDate;
